import { PageWorkflowStatus } from 'shared/types/global'

export const PAGE_STATUS_GRADIENTS: Record<
  PageWorkflowStatus,
  string | null
> = {
  [PageWorkflowStatus.default]: null,
  [PageWorkflowStatus.final]:
    'linear-gradient(140.71deg, #19E05D 15.68%, #99ECB5 84.55%)',
  [PageWorkflowStatus.inProgress]:
    'linear-gradient(140.71deg, #FF8325 15.68%, #FFCB97 84.55%)',
  [PageWorkflowStatus.inReview]:
    'linear-gradient(140.71deg, #00ABFF 15.68%, #97CEE8 84.55%)'
}

export const PAGE_STATUS_LABEL_IDS: Record<
  PageWorkflowStatus,
  string
> = {
  [PageWorkflowStatus.default]: 'Page.status.default',
  [PageWorkflowStatus.final]: 'Page.status.final',
  [PageWorkflowStatus.inProgress]: 'Page.status.inProgress',
  [PageWorkflowStatus.inReview]: 'Page.status.inReview'
}

export const SELECTABLE_PAGE_STATUSES = [
  PageWorkflowStatus.final,
  PageWorkflowStatus.inProgress,
  PageWorkflowStatus.inReview
]
